var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "2.5 3 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.735 3h16.88c.777 0 .89.79.556 1.185l-6.613 7.819c-.087.103-.242.28-.311.447-.084.203-.074.4-.074.547v7.003c0 .5-.508.745-1.015.492l-1.982-.992c-.246-.122-.646-.318-.833-.591-.194-.284-.17-.647-.17-.9v-5.004c0-.145.014-.355-.066-.555-.071-.175-.231-.342-.322-.45L3.174 4.185C2.84 3.789 2.965 3 3.735 3m.59 1 6.851 8v6.341l1.997.998V12l6.747-8z"
  })));
};
export default SvgFilter;